import { ComponentStylesWithFns } from '../../../theme/styles.helpers';

export const RequestModalStyles: ComponentStylesWithFns = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    backgroundColor: '#ebf2f6',
    borderRadius: '18px',
    overflow: 'hidden',
    position: 'relative',
    boxShadow: '0px 24px 60px 0px rgba(0,0,0,0.22)',
    boxSizing: 'border-box',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    height: '59px',
    minHeight: '59px',
    backgroundColor: 'white',
    borderBottom: '1px solid #dce4ee',
    padding: '0 16px',
    gap: '10px',
    flexShrink: 0,
  },
  typeBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    height: '21px',
    backgroundColor: '#ebf2ff',
    border: '1px solid #c7d2fe',
    borderRadius: '20px',
    padding: '0 10px',
    fontSize: '10px',
    fontWeight: 700,
    color: '#4881d7',
    whiteSpace: 'nowrap',
    flexShrink: 0,
  },
  requestId: {
    fontSize: '11px',
    color: '#a0aab9',
    fontWeight: 400,
  },
  closeButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '30px',
    height: '30px',
    minWidth: '30px',
    backgroundColor: '#ebf2f6',
    border: '1px solid #dce4ee',
    borderRadius: '8px',
    cursor: 'pointer',
    marginLeft: 'auto',
    fontSize: '20px',
    color: '#646e7d',
    flexShrink: 0,
    userSelect: 'none',
  },
  body: {
    display: 'flex',
    flex: 1,
    overflow: 'hidden',
    padding: '16px',
    gap: '16px',
  },
  leftColumn: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    gap: '12px',
    overflowY: 'auto',
    minWidth: 0,
  },
  rightColumn: {
    display: 'flex',
    flexDirection: 'column',
    width: '370px',
    minWidth: '280px',
    gap: '12px',
    overflowY: 'auto',
    flexShrink: 0,
  },

  card: {
    backgroundColor: 'white',
    border: '1px solid #dce4ee',
    borderRadius: '12px',
    padding: '16px',
    flexShrink: 0,
  },
  cardLabel: {
    fontSize: '10px',
    fontWeight: 700,
    color: '#a0aab9',
    textTransform: 'uppercase',
    letterSpacing: '1.5px',
    marginBottom: '10px',
  },
  productBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    height: '28px',
    backgroundColor: '#ebf2ff',
    borderRadius: '8px',
    padding: '0 13px',
    fontSize: '14px',
    fontWeight: 700,
    color: '#4881d7',
  },
  subscriptionBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    height: '21px',
    backgroundColor: '#fff8e6',
    border: '1px solid #f6ad55',
    borderRadius: '20px',
    padding: '0 10px',
    fontSize: '10px',
    fontWeight: 700,
    color: '#b7791f',
    whiteSpace: 'nowrap',
  },
  indicationText: {
    fontSize: '12px',
    color: '#646e7d',
    marginTop: '8px',
    // The indication may be a multi-select answer, i.e. one line per selection.
    whiteSpace: 'pre-line',
    '& strong': {
      color: '#111',
    },
  },
  infoGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '8px',
    marginBottom: '8px',
  },
  infoCell: {
    backgroundColor: '#ebf2f6',
    borderRadius: '8px',
    padding: '8px 11px 10px',
  },
  infoCellLabel: {
    fontSize: '10px',
    fontWeight: 600,
    color: '#a0aab9',
    marginBottom: '4px',
  },
  infoCellValue: {
    fontSize: '13px',
    fontWeight: 500,
    color: '#111',
  },
  countBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '21px',
    minWidth: '26px',
    backgroundColor: '#ebf2f6',
    border: '1px solid #dce4ee',
    borderRadius: '20px',
    padding: '0 8px',
    fontSize: '10px',
    fontWeight: 700,
    color: '#646e7d',
  },
  historyItem: {
    backgroundColor: '#ebf2f6',
    border: '1px solid #dce4ee',
    borderRadius: '9px',
    padding: '10px',
  },
  historyItemDate: {
    fontSize: '11px',
    color: '#a0aab9',
    marginBottom: '4px',
  },
  historyItemTitle: {
    fontSize: '12px',
    fontWeight: 600,
    color: '#111',
  },
  orderItem: {
    backgroundColor: '#ebf2f6',
    border: '1px solid #dce4ee',
    borderRadius: '9px',
    padding: '10px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  orderItemLeft: {
    flex: 1,
    minWidth: 0,
  },
  orderItemTitle: {
    fontSize: '12px',
    fontWeight: 600,
    color: '#111',
    marginBottom: '4px',
  },
  orderItemDate: {
    fontSize: '11px',
    color: '#a0aab9',
  },
  checkBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '32px',
    height: '23px',
    backgroundColor: '#dcfce7',
    border: '1px solid #86efac',
    borderRadius: '20px',
    fontSize: '10px',
    color: '#15803d',
    fontWeight: 700,
    flexShrink: 0,
  },
  deniedBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '32px',
    height: '23px',
    backgroundColor: '#fee2e2',
    border: '1px solid #fca5a5',
    borderRadius: '20px',
    fontSize: '10px',
    color: '#dc2626',
    fontWeight: 700,
    flexShrink: 0,
  },

  emptyText: {
    fontSize: '12px',
    color: '#a0aab9',
    textAlign: 'center',
    padding: '8px 0',
  },
  spinner: {
    color: '#4881d7',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: '-16px',
    marginLeft: '-16px',
    zIndex: 100,
  },
};
